import { render, staticRenderFns } from "./ClientDashboard.vue?vue&type=template&id=3b2327d4&"
import script from "./ClientDashboard.vue?vue&type=script&lang=ts&"
export * from "./ClientDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./ClientDashboard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports